export default __webpack_public_path__ + "static/media/hero.5a382424.jpg";